<script>
import Layout from '@layouts/primary'
import { vehicleMethods, wastetypeMethods, clientMethods, serviceMethods, serviceAgreementMethods, serviceTypeMethods, siteMethods, binMethods } from '@state/helpers'
import Collection from "../../components/collection"
import ServiceBins from "../../components/service-bins"
import { RRule, /* RRuleSet, */ rrulestr } from 'rrule'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'ViewService',
    meta: [{ name: 'description', content: 'ViewService' }],
  },
  components: {ServiceBins, Collection, Layout },
  data() {
    return {
      client: {},
      service: {},
      services: [],
      serviceAgreements: [],
      serviceAgreementID: null,

      serviceTypeSelectItems: [],  // Type {value, text}[]
      selectedServiceTypeId: null,
      wasteTypeSelectItems: [],  // Type {value, text}[]
      selectedWasteTypeId: null,
      vehicleSelectItems: [],  // Type {value, text}[]
      selectedVehicleId: null,

      serviceSearchInput:'',
      wasteSearchInput:'',
      vehicles: [],
      vehiclePlates: [],
      serviceSchedule: {
        freq: null,
        // count: 5,
        interval: null,
        byweekday:[],
        bymonth: [],
      },
      newService: {
        service_title: null,
        service_type_id: null,
        client_id: null,
        site_id: null,
        description: null,
        is_recurring: true,
        schedule_string: "RRULE:FREQ=DAILY;WKST=MO",
        // schedule_string: "RRULE:FREQ=DAILY;COUNT=30;WKST=MO",
        serviceOnCall: false, // false as default
        time_windows:[[100,2400]],
        order_number: null,
        service_agreement_id: null,
        serviceScheduleOld: {
          byweekdayObj:{
            mon: false,
            tue: false,
            wed: false,
            thu: false,
            fri: false,
            sat: false,
            sun: false,
          },
          byMonthObj:{
            jan: false,
            feb: false,
            mar: false,
            apr: false,
            may: false,
            jun: false,
            jul: false,
            ago: false,
            sep: false,
            oct: false,
            nov: false,
            dec: false,
          }
        },
        serviceSchedule: {
          freq: null,
          // count: 5,
          interval: null,
          byweekday:[],
          bymonth: [],
          until: ''
        },
      },
      newServiceAgreement: {
        gateAccessMethod: '00:00',
        clientId: null,
        siteId: null,
        notes: null,
        agreementCommencementDate: null,
        deliveryDate: null,
        firstPickup: null,
      },
      clientSites:[],
      allTheBins: [],
      binType: null,
      binDescriptions:[],
      newServiceBin: {
        binId: null,
        serviceId: null,
        price:null,
        binIdentifier:null,
        defaultPricing: true,
        issueDate: null,
        weeklyMaintenanceFee: null,
      },
      removeClient:false,
      editClient:false,
      addLocation:false,
      newSite: {
        address: null,
        suburb: null,
        state: null,
        country: null,
        postcode: null,
        clientId: null,
        phone: null,
        mobile: null,
        contactName: null,
        email: null,
        tradingName: null,
      },
      editService: false,
      removeService:false,
      newBin: false,
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
        },
      },
      binHeaders: [
        { text: 'Type', value: 'type' },
        { text: 'Capacity', value: 'capacity' },
        { text: 'Price', value: 'price' },
        { text: 'Maintenance Fee', value: 'maintenance_fee' },
        { text: 'Actions', value: 'name', sortable: false },
      ],
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    let id = this.$router.history.current.params.id
    this.newService.serviceSchedule.until = this.$router.history.current.params.last_day_service
    this.getServiceById({id: id}).then(response => {
      let formattedService = { ...this.$store.state.services.currentService }
      formattedService.value = true
      this.selectedServiceTypeId = formattedService.service_type_id.id
      this.selectedWasteTypeId = formattedService.waste_type.id
      this.selectedVehicleId = formattedService.vehicle ? formattedService.vehicle.id : null

      // display schedule based on RRule
      if(formattedService.schedule_string !== 'ON CALL'){
        // Remove COUNT=5 from the string - REMOVED IT AS IT WASN'T DOING THE CONVERSION RIGHT
        // let scheduleStr = formattedService.schedule_string.split(';');
        let scheduleStr = formattedService.schedule_string
        let rule = RRule.fromString(scheduleStr);
        formattedService.schedule_string_formatted = rule.toText()
        this.newService.serviceSchedule = rule.origOptions

        let byweekdayObj = {
          mon: false,
          tue: false,
          wed: false,
          thu: false,
          fri: false,
          sat: false,
          sun: false,
        };

        let byMonthObj = {
          jan: false,
          feb: false,
          mar: false,
          apr: false,
          may: false,
          jun: false,
          jul: false,
          ago: false,
          sep: false,
          oct: false,
          nov: false,
          dec: false,
        };

        this.newService.serviceScheduleOld.byweekdayObj = byweekdayObj
        this.newService.serviceScheduleOld.byMonthObj = byMonthObj

        // build the weekday obj based on the schedule string
        for(let i in this.newService.serviceSchedule.byweekday){
          switch (this.newService.serviceSchedule.byweekday[i].weekday) {
          case 0:
            // console.log('Monday');
            this.newService.serviceScheduleOld.byweekdayObj.mon = true;
            break;
          case 1:
            // console.log('Tuesday');
            this.newService.serviceScheduleOld.byweekdayObj.tue = true;
            break;
          case 2:
            // console.log('Wed');
            this.newService.serviceScheduleOld.byweekdayObj.wed = true;
            break;
          case 3:
            // console.log('Thu');
            this.newService.serviceScheduleOld.byweekdayObj.thu = true;
            break;
          case 4:
            // console.log('Fri');
            this.newService.serviceScheduleOld.byweekdayObj.fri = true;
            break;
          case 5:
            // console.log('Sat');
            this.newService.serviceScheduleOld.byweekdayObj.sat = true;
            break;
          case 6:
            // console.log('Sun');
            this.newService.serviceScheduleOld.byweekdayObj.sun = true;
            break;
          }
        }

        // build the by the month obj based on the schedule string
        for(let i in this.newService.serviceSchedule.bymonth){
          switch (this.newService.serviceSchedule.bymonth[i]) {
          case 1:
            this.newService.serviceScheduleOld.byMonthObj.jan = true;
            break;
          case 2:
            this.newService.serviceScheduleOld.byMonthObj.feb = true;
            break;
          case 3:
            this.newService.serviceScheduleOld.byMonthObj.mar = true;
            break;
          case 4:
            this.newService.serviceScheduleOld.byMonthObj.apr = true;
            break;
          case 5:
            this.newService.serviceScheduleOld.byMonthObj.may = true;
            break;
          case 6:
            this.newService.serviceScheduleOld.byMonthObj.jun = true;
            break;
          case 7:
            this.newService.serviceScheduleOld.byMonthObj.jul = true;
            break;
          case 8:
            this.newService.serviceScheduleOld.byMonthObj.ago = true;
            break;
          case 9:
            this.newService.serviceScheduleOld.byMonthObj.sep = true;
            break;
          case 10:
            this.newService.serviceScheduleOld.byMonthObj.oct = true;
            break;
          case 11:
            this.newService.serviceScheduleOld.byMonthObj.nov = true;
            break;
          case 12:
            this.newService.serviceScheduleOld.byMonthObj.dec = true;
            break;
          }
        }
      } else {
        formattedService.schedule_string_formatted = 'On Call';
        this.newService.serviceOnCall = true
      }

      this.service = formattedService
      this.newService.service_title = formattedService.service_title
      if(formattedService.vehicle && formattedService.vehicle.number_plate)
        this.newService.vehicle_id = formattedService.vehicle.number_plate

    })
    this.getServiceTypes().then(response => {
      let obj = this.$store.state.serviceTypes.objects
      for (var v in obj) {
        let formattedObj = {
          ...obj[v]
        }
        if(formattedObj.active) {
          this.serviceTypeSelectItems.push(
            {
              value: formattedObj.id,
              text: formattedObj.name
            }
          )
        }
      }
    })
    this.getWasteTypes().then(response => {
      let obj = this.$store.state.wastetypes.objects
      for (let v in obj) {
        let formattedObj = {
          ...obj[v]
        }
        this.wasteTypeSelectItems.push(
          {
            value: formattedObj.id,
            text: formattedObj.name
          }
        )
      }
    })
    this.getBins().then(response => {
      let bin = this.$store.state.bins.objects
      for (let bi in bin) {
        this.binDescriptions.push(bin[bi].description)
        this.allTheBins.push(bin[bi])
      }
    })
    this.getVehicles().then(response => {
      let obj = this.$store.state.vehicles.objects
      for (let v in obj) {
        this.vehicleSelectItems.push(
          {
            value: obj[v].id,
            text: obj[v].number_plate
          }
        )
      }
    })
  },
  methods: {
    ...vehicleMethods,...wastetypeMethods, ...clientMethods, ...serviceMethods, ...serviceAgreementMethods, ...siteMethods, ...serviceTypeMethods, ...binMethods,
    async update() {
      await this.$validator.validateAll('form-service').then(result => {
        // console.log(result)
        if(result) {
          this.newService.id = parseInt(this.service.id)
          // console.log(this.newService.serviceOnCall)
          // If admin define that the service is based up On Call
          if(this.newService.serviceOnCall){
            this.newService.schedule_string = 'ON CALL';
          }

          this.newService.service_type_id = parseInt(this.selectedServiceTypeId)
          this.newService.waste_type_id = parseInt(this.selectedWasteTypeId)
          this.newService.vehicle_id = this.selectedVehicleId ? parseInt(this.selectedVehicleId) : null

          if(this.newService.serviceSchedule){
            // clean by week day array to recreate it based on the inputs
            this.newService.serviceSchedule.byweekday = []
            // monday = 0 .. tuesday = 1...
            if(this.newService.serviceScheduleOld.byweekdayObj.mon){
              this.newService.serviceSchedule.byweekday.push(0)
            }
            if(this.newService.serviceScheduleOld.byweekdayObj.tue){
              this.newService.serviceSchedule.byweekday.push(1)
            }
            if(this.newService.serviceScheduleOld.byweekdayObj.wed){
              this.newService.serviceSchedule.byweekday.push(2)
            }
            if(this.newService.serviceScheduleOld.byweekdayObj.thu){
              this.newService.serviceSchedule.byweekday.push(3)
            }
            if(this.newService.serviceScheduleOld.byweekdayObj.fri){
              this.newService.serviceSchedule.byweekday.push(4)
            }
            if(this.newService.serviceScheduleOld.byweekdayObj.sat){
              this.newService.serviceSchedule.byweekday.push(5)
            }
            if(this.newService.serviceScheduleOld.byweekdayObj.sun){
              this.newService.serviceSchedule.byweekday.push(6)
            }


            // clean by month array to recreate it based on the inputs
            this.newService.serviceSchedule.bymonth = []

            if(this.newService.serviceScheduleOld.byMonthObj.jan){
              this.newService.serviceSchedule.bymonth.push(1)
            }

            if(this.newService.serviceScheduleOld.byMonthObj.feb){
              this.newService.serviceSchedule.bymonth.push(2)
            }

            if(this.newService.serviceScheduleOld.byMonthObj.mar){
              this.newService.serviceSchedule.bymonth.push(3)
            }

            if(this.newService.serviceScheduleOld.byMonthObj.apr){
              this.newService.serviceSchedule.bymonth.push(4)
            }

            if(this.newService.serviceScheduleOld.byMonthObj.may){
              this.newService.serviceSchedule.bymonth.push(5)
            }

            if(this.newService.serviceScheduleOld.byMonthObj.jun){
              this.newService.serviceSchedule.bymonth.push(6)
            }

            if(this.newService.serviceScheduleOld.byMonthObj.jul){
              this.newService.serviceSchedule.bymonth.push(7)
            }

            if(this.newService.serviceScheduleOld.byMonthObj.ago){
              this.newService.serviceSchedule.bymonth.push(8)
            }

            if(this.newService.serviceScheduleOld.byMonthObj.sep){
              this.newService.serviceSchedule.bymonth.push(9)
            }

            if(this.newService.serviceScheduleOld.byMonthObj.oct){
              this.newService.serviceSchedule.bymonth.push(10)
            }

            if(this.newService.serviceScheduleOld.byMonthObj.nov){
              this.newService.serviceSchedule.bymonth.push(11)
            }

            if(this.newService.serviceScheduleOld.byMonthObj.dec){
              this.newService.serviceSchedule.bymonth.push(12)
            }

            let schedule = new RRule(this.newService.serviceSchedule)
            this.newService.schedule_string = schedule.toString()
          }

          if(this.newService.serviceOnCall){
            this.newService.schedule_string = 'ON CALL';
          }

          // console.log('new service', this.newService)
          this.updateService(this.newService).then( d => {
            this.editService = !this.editService
            location.reload()
          })
        }
      });
    },
    cancelEditService() {
      this.editService = false
      this.selectedServiceTypeId = this.service.service_type_id.id
      this.selectedWasteTypeId = this.service.waste_type.id
      this.selectedVehicleId = formattedService.vehicle ? formattedService.vehicle.id : null
    },
    submit() {
      let sid = parseInt(this.service.id)
      let route = '/admin/view-client/'
      route = route.concat(this.service.client_id.id)
      this.updateService({id: sid, active: false}).then( d => {
        this.changeRoute(route)
        location.reload()
      })
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    findVehicleByPlate(plate){
      return this.vehicles.find(obj => obj.number_plate === plate)
    },
    rulify(s) {
      return rrulestr(s).toText().toUpperCase();
    },
    Daily() {
      // console.log(RRule.DAILY)
      return RRule.DAILY
    },
    Weekly() {
      // console.log(RRule.WEEKLY)
      return RRule.WEEKLY
    },
    Monthly() {
      // console.log(RRule.MONTHLY)
      return RRule.MONTHLY
    },
    Yearly() {
      // console.log(RRule.YEARLY)
      return RRule.YEARLY
    },
  }
}
</script>

<template>
  <Layout>
    <VContainer grid-list-md>
      <h2>View Service</h2>
      <VCard class="v-card-padding top-blue">
        <VLayout>
          <VFlex
            v-if="service"
            style="padding: 15px;"
          >
            <p v-if="service">
              <strong> {{ service.service_title }}</strong>
            </p>
            <p v-if="service">
              {{ service.description }}
            </p>
            <!--<p v-if="service" /><p><strong>Client:&nbsp&nbsp</strong>{{ getClientName() }}</p>-->
            <p v-if="service.waste_type">
              <strong>Waste Type:</strong>{{ service.waste_type.name }}
            </p>
            <p v-if="service.service_type_id">
              <strong>Type:</strong>{{ service.service_type_id.name }}
            </p>
            <p v-if="service.vehicle">
              <strong>Preferred Vehicle:</strong>{{ service.vehicle.number_plate }}
            </p>
            <p><strong>Schedule:</strong>{{ service.schedule_string_formatted }}</p>
            <!--<p><strong>Order Number:</strong>{{ service.order_number }}</p>-->
          </VFlex>
        </VLayout>
        <VSpacer />

        <VLayout
          row
          wrap
        >

          <VFlex
            xs12
            sm3
            style="padding: 15px 15px 0 15px"
          >
            <VBtn
              color="blue"
              block
              outline
              @click.native="editService = !editService"
            >
              EDIT
            </VBtn>
          </VFlex>
          <VFlex
            xs12
            sm3
            style="padding: 15px;"
          >
            <VBtn
              v-if="this.$store.getters['auth/getUserRole'] == 'Admin'"
              color="orange"
              block
              @click.native="removeService = !removeService"
            >
              Delete
            </VBtn>
          </VFlex>
        </VLayout>
      </VCard>

      <VSpacer />
      <br>
      <ServiceBins
        :bin="service.service_bins"
        :service-id="service.id"
      />

      <Collection :service="service" />

      <!-- Update SERVICE MODAL -->
      <VLayout
        row
        justify-center
      >
        <VDialog
          v-model="editService"
          persistent
          scrollable
          max-width="500px"
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <h2>Edit Service</h2>
                <VLayout
                  wrap
                  data-vv-scope="form-service"
                >
                  <VFlex xs12>
                    <VTextField
                      v-model="newService.service_title"
                      v-validate="'required'"
                      data-vv-scope="form-service"
                      data-vv-name="title"
                      label="Title"
                      required
                    />
                    <p
                      v-if="errors.has('form-service.title')"
                      class="theme--light v-messages"
                    >
                      {{ errors.first('form-service.title') }}
                    </p>
                  </VFlex>
                  <VFlex xs12>
                    <VAutocomplete
                      v-model="selectedServiceTypeId"
                      data-vv-scope="form-service"
                      data-vv-name="service_type"
                      :items="serviceTypeSelectItems"
                      label="Service Type"
                      :menu-props="{ absolute: true }"
                      attach
                      :search-input.sync="serviceSearchInput"
                    />
                    <p
                      v-if="errors.has('form-service.service_type')"
                      class="theme--light v-messages"
                    >
                      {{ errors.first('form-service.service_type') }}
                    </p>
                  </VFlex>
                  <VFlex xs12>
                    <VAutocomplete
                      v-model="selectedWasteTypeId"
                      data-vv-scope="form-service"
                      data-vv-name="waste_type"
                      :items="wasteTypeSelectItems"
                      label="Waste Type"
                      :menu-props="{ absolute: true }"
                      attach
                      :search-input.sync="wasteSearchInput"
                    />
                    <p
                      v-if="errors.has('form-service.waste_type')"
                      class="theme--light v-messages"
                    >
                      {{ errors.first('form-service.waste_type') }}
                    </p>
                  </VFlex>
                  <VFlex xs6>
                    <VTextField
                      v-model="newService.time_windows[0][0]"
                      type="number"
                      label="Time Window Start"
                      required
                      :menu-props="{ absolute: true }"
                    />
                  </VFlex>
                  <VFlex xs6>
                    <VTextField
                      v-model="newService.time_windows[0][1]"
                      type="number"
                      label="Time Window End"
                      required
                      :menu-props="{ absolute: true }"
                    />
                  </VFlex>

                  <VFlex xs12>
                    <h3>Service Schedule</h3>
                  </VFlex>
                  <VFlex xs12>
                    <VCheckbox
                      v-model="newService.serviceOnCall"
                      label="On Call service"
                    />
                  </VFlex>
                  <VFlex xs12>
                    <VSelect
                      v-model="newService.serviceSchedule.freq"
                      v-validate="!newService.serviceOnCall ? 'required' : ''"
                      data-vv-scope="form-service"
                      data-vv-name="frequency"
                      :items="[
                        {freq: 'Daily', rule: Daily() },
                        {freq: 'Weekly', rule: Weekly() },
                        {freq: 'Monthly', rule: Monthly() },
                        {freq: 'Annually', rule: Yearly() },
                      ]"
                      item-text="freq"
                      item-value="rule"
                      label="Frequency"
                      required
                      :menu-props="{ absolute: true }"
                      attach
                    />
                    <p
                      v-if="errors.has('form-service.frequency')"
                      class="theme--light v-messages"
                    >
                      {{ errors.first('form-service.frequency') }}
                    </p>
                  </VFlex>
                  <VFlex xs12>
                    <VExpansionPanel
                      expand
                      inset
                    >
                      <VExpansionPanelContent inset>
                        <div slot="header">
                          Set Days of Week
                        </div>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byweekdayObj.mon"
                            label="Monday"
                            color="secondary"
                            :value="newService.serviceScheduleOld.byweekdayObj.mon ? newService.serviceScheduleOld.byweekdayObj.mon : 0"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byweekdayObj.tue"
                            label="Tuesday"
                            color="primary"
                            :value="newService.serviceScheduleOld.byweekdayObj.tue ? newService.serviceScheduleOld.byweekdayObj.tue : 1"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byweekdayObj.wed"
                            label="Wednesday"
                            color="secondary"
                            :value="newService.serviceScheduleOld.byweekdayObj.wed ? newService.serviceScheduleOld.byweekdayObj.wed : 2"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byweekdayObj.thu"
                            label="Thursday"
                            color="primary"
                            :value="newService.serviceScheduleOld.byweekdayObj.thu ? newService.serviceScheduleOld.byweekdayObj.thu : 3"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byweekdayObj.fri"
                            label="Friday"
                            color="secondary"
                            :value="newService.serviceScheduleOld.byweekdayObj.fri ? newService.serviceScheduleOld.byweekdayObj.fri : 4"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byweekdayObj.sat"
                            label="Saturday"
                            color="primary"
                            :value="newService.serviceScheduleOld.byweekdayObj.sat ? newService.serviceScheduleOld.byweekdayObj.sat : 5"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byweekdayObj.sun"
                            label="Sunday"
                            color="secondary"
                            :value="newService.serviceScheduleOld.byweekdayObj.sun ? newService.serviceScheduleOld.byweekdayObj.sun : 6"
                            hide-details
                          />
                        </VFlex>
                      </vexpansionpanelcontent>
                    </vexpansionpanel>
                  </VFlex>
                  <VFlex xs12>
                    <VExpansionPanel
                      expand
                      inset
                    >
                      <VExpansionPanelContent inset>
                        <div slot="header">
                          Set Months of Year
                        </div>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byMonthObj.jan"
                            label="Jan"
                            color="secondary"
                            :value="newService.serviceScheduleOld.byMonthObj.jan ? newService.serviceScheduleOld.byMonthObj.jan : 1"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byMonthObj.feb"
                            label="Feb"
                            color="primary"
                            :value="newService.serviceScheduleOld.byMonthObj.feb ? newService.serviceScheduleOld.byMonthObj.feb : 2"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byMonthObj.mar"
                            label="Mar"
                            color="secondary"
                            :value="newService.serviceScheduleOld.byMonthObj.mar ? newService.serviceScheduleOld.byMonthObj.mar : 3"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byMonthObj.apr"
                            label="Apr"
                            color="primary"
                            :value="newService.serviceScheduleOld.byMonthObj.apr ? newService.serviceScheduleOld.byMonthObj.apr : 4"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byMonthObj.may"
                            label="May"
                            color="secondary"
                            :value="newService.serviceScheduleOld.byMonthObj.may ? newService.serviceScheduleOld.byMonthObj.may : 5"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byMonthObj.jun"
                            label="Jun"
                            color="secondary"
                            :value="newService.serviceScheduleOld.byMonthObj.jun ? newService.serviceScheduleOld.byMonthObj.jun : 6"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byMonthObj.jul"
                            label="Jul"
                            color="primary"
                            :value="newService.serviceScheduleOld.byMonthObj.jul ? newService.serviceScheduleOld.byMonthObj.jul : 7"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byMonthObj.ago"
                            label="Aug"
                            color="secondary"
                            :value="newService.serviceScheduleOld.byMonthObj.ago ? newService.serviceScheduleOld.byMonthObj.ago : 8"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byMonthObj.sep"
                            label="Sep"
                            color="primary"
                            :value="newService.serviceScheduleOld.byMonthObj.sep ? newService.serviceScheduleOld.byMonthObj.sep : 9"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byMonthObj.oct"
                            label="Oct"
                            color="secondary"
                            :value="newService.serviceScheduleOld.byMonthObj.oct ? newService.serviceScheduleOld.byMonthObj.oct : 10"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byMonthObj.nov"
                            label="Nov"
                            color="primary"
                            :value="newService.serviceScheduleOld.byMonthObj.nov ? newService.serviceScheduleOld.byMonthObj.nov : 11"
                            hide-details
                          />
                        </VFlex>
                        <VFlex xs4>
                          <VCheckbox
                            v-model="newService.serviceScheduleOld.byMonthObj.dec"
                            label="Dec"
                            color="secondary"
                            :value="newService.serviceScheduleOld.byMonthObj.dec ? newService.serviceScheduleOld.byMonthObj.dec : 12"
                            hide-details
                          />
                        </VFlex>
                      </vexpansionpanelcontent>
                    </vexpansionpanel>
                  </VFlex>
                  <VFlex xs12>
                    <VTextField
                      v-model="newService.serviceSchedule.interval"
                      type="number"
                      label="Interval between collections"
                      required
                      :menu-props="{ absolute: true }"
                    />
                  </VFlex>
                  <VFlex xs12>
                    <VSelect
                      v-model="selectedVehicleId"
                      data-vv-name="vehicle"
                      :items="vehicleSelectItems"
                      label="Preferred Vehicle"
                      :menu-props="{ absolute: true }"
                      attach
                    />
                    <p class="caption">Preferred Vehicle: The scheduler will place this service on a route that matches the selected preferred vehicle. If a preferred vehicle is not set the scheduler will place the service on a route that matches this service's Waste Type and Bin Type.</p>
                  </VFlex>
                  <VSpacer />

                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="cancelEditService()"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      @click.native="update()"
                    >
                      Save
                    </VBtn>
                  </VFlex>
                </VLayout>
              </VContainer>
            </VCardText>
          </VCard>
        </VDialog>
      </VLayout>

      <VLayout
        row
        justify-center
      >
        <VDialog
          v-model="removeService"
          persistent
          max-width="500px"
          scrollable
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <h2>Are you sure you want to delete {{ service.id }}?</h2>
                <VLayout wrap>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="removeService = !removeService"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="orange"
                      block
                      @click.native="submit()"
                    >
                      DELETE
                    </VBtn>
                  </VFlex>
                </VLayout>
              </VContainer>
            </VCardText>
          </VCard>
        </VDialog>
      </VLayout>
    </vcontainer>
  </layout>
</template>
<!--</vdatatable>-->
<!--</VContainer>-->
  <!--</Layout>-->
<!--</template>-->

<style lang="scss" module>
    @import '@design';
</style>
